import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';

import {
  isGeoMotionVideo,
  isMaps,
  isIAS,
  isBoilerPlate,
  isLuminarias
} from '../../../modules/checkDeployEnv';

const { productName, visualizerLogo } = Meteor.settings.public;

const SRM_LOGO = '/ias-logo/srm.png';
const GMV_LOGO = `/ias-logo/${visualizerLogo}.png`;

const CompanyLogo = ({ alignRight, deployEnv, height, showLogo }) => {
  let companyLogo = '';
  switch (true) {
    case isIAS(deployEnv):
    case isMaps(deployEnv):
    case isBoilerPlate(deployEnv):
    case isLuminarias(deployEnv):
      companyLogo = SRM_LOGO;
      break;
    case isGeoMotionVideo(deployEnv):
      companyLogo = GMV_LOGO;
      break;
    default:
      companyLogo = '';
      break;
  }

  if (!showLogo) {
    return '';
  }

  return (
    <img
      className={alignRight ? 'float-right' : ''}
      src={companyLogo}
      height={height}
      alt={productName}
    />
  );
};

CompanyLogo.defaultProps = {
  alignRight: false,
  height: 60,
  showLogo: true
};

CompanyLogo.propTypes = {
  alignRight: PropTypes.bool,
  deployEnv: PropTypes.string.isRequired,
  height: PropTypes.number,
  showLogo: PropTypes.bool
};

export default CompanyLogo;
